export default __webpack_public_path__ + "static/ibrahim-410378486d66700218cfc5ca0e69ec0e.jpeg";